// extracted by mini-css-extract-plugin
export var banner = "_3f-0";
export var icon = "_3f-1";
export var message = "_3f-2";